import React from "react";
import PropTypes from "prop-types";

const WildcardSwitch = ({
  currentSwitchState,
  disabled = false,
  handleChange,
  id,
  switchRef,
  isSelected,
}) => {
  const triggerTextAnimation = (e) => {
    const buttonClassList = e.currentTarget.classList;
    const textAnimation = "dictionary_switch__container__text_appearence";
    if (buttonClassList.contains(textAnimation)) {
      buttonClassList.remove(textAnimation);
    }
    setTimeout(() => {
      buttonClassList.add(textAnimation);
    }, 0);
  };

  const handleClick = (e) => {
    handleChange(e);
    triggerTextAnimation(e);
  };

  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    <button
        className="dictionary_switch__container"
        id={id}
        onClick={handleClick}
        type="button"
        ref={switchRef}
        disabled={disabled}
        data-testid="wildcard-switch"
      >
        <span
          className={`switch__slider${currentSwitchState ? " active" : ""}${
            disabled ? " disabled" : ""
          }${isSelected ? " selected" : ""}`}
          data-testid="switch-slider"
        >
          &nbsp;
        </span>
      </button>
  );
};

export default WildcardSwitch;

WildcardSwitch.propTypes = {
  currentSwitchState: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  switchRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // An object
    PropTypes.object,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  isSelected: PropTypes.bool,
};
